module.exports = __webpack_public_path__ + "img/360.35596531.svg";